import React from 'react';
import { defineMessages, t } from '@sm/intl';
import { MainNavButton } from '../nav-button';

const COPY = defineMessages({
  MANAGE: {
    id: 'Manage.manage',
    defaultMessage: 'Manage',
    description: '[Type: Label][Vis.: low] - Manage link in main navigation',
  },
});

const Manage = () => (
  <MainNavButton href="/apps/my-apps" label={t(COPY.MANAGE)} />
);

export default Manage;
export { Manage };
